"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const constants_1 = require("../../constants");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {},
    searchContainer: {
        paddingTop: theme_1.Spacing.medium,
    },
    choiceGroupsContainer: {
        paddingTop: theme_1.Spacing.small,
    },
    choiceGroupContainer: {
        '&:not(:first-of-type)': {
            borderTop: `1px solid ${design_system_1.Colors.grey200}`,
        },
    },
    choiceGroup: {
        alignItems: 'center',
        color: design_system_1.Colors.black,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        padding: `${theme_1.Spacing.small}px 0px`,
        '&:focus': {
            color: design_system_1.Colors.blue500,
        },
    },
    choiceGroupLabel: {
        display: 'flex',
        alignItems: 'center',
    },
    choiceGroupLabelText: Object.assign(Object.assign({}, design_system_1.Typography.subtitle700), { color: 'inherit', fontSize: 14 }),
    choiceGroupArrow: {
        display: 'flex',
        padding: `0px ${theme_1.Spacing.small}px`,
    },
    choiceGroupTopOptionsContainer: {
        marginBottom: theme_1.Spacing.small,
    },
    choiceGroupButtonContainer: {
        margin: `${theme_1.Spacing.small}px 0px`,
    },
    choiceItemsContainer: {
        maxHeight: constants_1.MAX_DROPDOWN_OPTIONS_HEIGHT,
        maxWidth: '100%',
        overflow: 'auto',
        paddingRight: theme_1.Spacing.extraSmall,
        '::-webkit-scrollbar': {
            background: 'transparent',
            height: theme_1.Spacing.extraSmall,
            width: theme_1.Spacing.extraSmall,
        },
        '::-webkit-scrollbar-thumb': {
            background: design_system_1.Colors.grey300,
            borderRadius: theme_1.Border.radius.default,
        },
    },
    choiceItemContainer: {
        margin: `${theme_1.Spacing.extraSmall}px 0px`,
    },
    choiceItem: {
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        padding: theme_1.Spacing.extraSmall,
        borderRadius: 10,
        border: `1px solid ${design_system_1.Colors.grey200}`,
        '&:hover': {
            borderColor: design_system_1.Colors.blue500,
            borderWidth: 2,
            padding: theme_1.Spacing.extraSmall - 1,
        },
        '&:focus': {
            borderColor: design_system_1.Colors.blue500,
            borderWidth: 2,
            padding: theme_1.Spacing.extraSmall - 1,
        },
    },
    choiceItemLabel: Object.assign(Object.assign({}, design_system_1.Typography.altText800), { color: design_system_1.Colors.black, fontWeight: 600, paddingLeft: theme_1.Spacing.small, whiteSpace: 'pre' }),
    choiceItemSample: {
        lineHeight: '100%',
        whiteSpace: 'nowrap',
    },
    addSearchStepContainer: {
        marginTop: theme_1.Spacing.small,
    },
});
exports.default = Styles;
